import React, { useState } from "react";
import { useSelector } from "react-redux";
import ProspectsFilters from "./ProspectFilters";
import ProspectStats from "./ProspectStats/ProspectStats";
import ProspectTable from "./ProspectTable/ProspectTable";
import { useTranslation } from "react-i18next";
import ProspectMap from "./ProspectMap/ProspectMap";

const ProspectsViewContent = () => {
  const { t } = useTranslation("common");
  const [filters, setFilters] = useState({});
  const { user } = useSelector((state) => state.userReducer);
  const userRole = user?.attributes?.userRole;

  return (
    <div className="flex-1 prospect">
      <div className="">
        <h2 className="text-blue bold f30 mb-1">{t("Store Prospect")}</h2>
        <ProspectsFilters filters={filters} setFilters={setFilters} />
        <ProspectStats filters={filters} userRole={userRole} />
        <ProspectMap extraFilters={filters} />
        <ProspectTable extraFilters={filters} />
      </div>
    </div>
  );
};

export default ProspectsViewContent;
